import React from "react";
import { Outlet } from "react-router-dom";
import "../styles/app.scss";

export default function Root() {
  return (
    <div>
      <Outlet />
    </div>
  );
}
